import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Trigger } from "@radix-ui/react-dropdown-menu";
import { DropdownMenu } from "../dropdown-menu/index.js";
const ToolbarMenuRoot = (t0) => {
  const $ = c(12);
  let button;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      button,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = button;
    $[2] = children;
    $[3] = props;
  } else {
    button = $[1];
    children = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== button) {
    t1 = /* @__PURE__ */ jsx(Trigger, { asChild: true, children: button });
    $[4] = button;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = /* @__PURE__ */ jsx(DropdownMenu.Content, { children });
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = /* @__PURE__ */ jsxs(DropdownMenu, { ...props, children: [
      t1,
      t2
    ] });
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
const ToolbarMenu = Object.assign(ToolbarMenuRoot, {
  Item: DropdownMenu.Item
});
export {
  ToolbarMenu
};
//# sourceMappingURL=index.js.map
